<form [formGroup]="environmentFormGroup" (ngSubmit)="handleFormSubmit()" id="environment-form" class="env-form"
#myForm="ngForm">
  <div class="col-sm-12 p-0">
    <mat-form-field appearance="fill" class="w-60">
      <mat-label>Environment Name</mat-label>
      <input matInput type="text" maxlength="75" autocomplete="off" formControlName="environmentName" required
        (paste)="on_paste_omit_special_char($event, 'environmentName', [32])"
        (keypress)="omit_special_char($event, true, [32])" aria-labelledby="my-label-environmentName"
        aria-describedby="my-helper-environmentName" [readonly]="mode === 'edit'" />
      <mat-icon matSuffix matTooltip="{{ configEnvironmentNameInfoMsg }}" matTooltipPosition="right" aria-hidden="true"
        matTooltipClass="ey-custom-tooltip">info</mat-icon>
    </mat-form-field>
  </div>
  <div class="col-sm-12 p-0">
  <mat-form-field  appearance="fill" class="w-60 h-50">
    <mat-label class="envTypeLabel">Environment Type</mat-label>
    <mat-select formControlName="environmentType" aria-label="Environment Type" >
      <mat-option value="Staging">Staging</mat-option>
      <mat-option value="Production">Production</mat-option>
    </mat-select>
  </mat-form-field>
</div>

  <div class="col-sm-12 p-0">
    <mat-form-field appearance="fill" class="w-60">
      <mat-label>Environment Deployment GitHub Action Workflow Name</mat-label>
      <input
        matInput
        type="text"
        maxlength="256"
        formControlName="workflowName"
        placeholder="e.g. Release_Pipeline-Dev.yml"
        aria-label="workflowName"
      />
      <mat-icon matSuffix matTooltip="Name of the GitHub Action workflow for deployment. Max length: 256 characters."
        matTooltipPosition="right" aria-hidden="true"
        matTooltipClass="ey-custom-tooltip">info</mat-icon>
      </mat-form-field>
  </div>

   <label for="mapService" class="map-services-title">
    Map Services
    <mat-icon 
        matSuffix
        mat-icon-button
        matTooltip="Map at least one service with relevant details to activate environment"
        matTooltipPosition="above"
        style="font-size: 18px; height: 20px;"
        matTooltipClass="ey-custom-tooltip" 
        >info</mat-icon
      >
   </label>
  <div class="card">
    <p-table [value]="availableServices" [scrollable]="true" scrollHeight="calc(100vh - 400px)" [tableStyle]="{'min-width': '50rem'}" styleClass="custom-scroll-table">

      <ng-template pTemplate="header">
        <tr>
          <th id="select_Service" class="th-10" >
            
      
          </th>
          <th id="service_Name" class="th-20">Service Name</th>
          <th id="API_External_URL" class="th-35">
            <span style="display: flex; align-items: center;">
              API External URL
              <mat-icon matSuffix matTooltipClass="ey-custom-tooltip"  mat-icon-button matTooltip="Provide valid API External URL of the service"
                matTooltipPosition="above" style="font-size: 18px; height: 20px; margin-left: 4px;">info</mat-icon>
            </span>
          </th>
        <th id="Lego_Remote_javacript_URL" class="th-35">
          <span style="display: flex; align-items: center;">
            Lego Remote JavaScript URL
            <mat-icon matSuffix matTooltipClass="ey-custom-tooltip"  mat-icon-button matTooltip="Provide valid Lego Remote JavaScript URL of the service"
              matTooltipPosition="above" style="font-size: 18px; height: 20px; margin-left: 4px;">info</mat-icon>
          </span>
        </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr [formGroup]="servicesFormArray.at(rowIndex)">
          <td>
            <mat-checkbox  class="fids-primary-checkbox" type="checkbox" formControlName="selected" (change)="onServiceCheckboxChange($event, rowIndex)">
            </mat-checkbox>
          </td>
          <td>{{ row.serviceName }}</td>
          <td>
             @if(row.hasAPI){
            <mat-form-field appearance="fill" class="w-100 no-infix-padding">
                <textarea matInput
                          formControlName="apiUrl"
                          rows="2"
                          cols="30"
                          class="w-100 ">
                </textarea>
              </mat-form-field>
            }
          </td>
          <td>
             @if(row.hasWeb){
              <mat-form-field appearance="fill" class="w-100 no-infix-padding">
                <textarea matInput
                          formControlName="webUrl"
                          rows="2"
                          cols="30"
                          class="w-100 ">
                </textarea>
              </mat-form-field>
             }
          </td>
        </tr>
      </ng-template>
     </p-table>
  </div>
<div class="active-checkbox-row" style="display: flex; align-items: center;">
  <mat-checkbox style="margin-left: 12px;"
   class="fids-primary-checkbox" type="checkbox"
    formControlName="isActive"
    [disabled]="environmentFormGroup.get('isActive')?.disabled ?? false">
  </mat-checkbox>
  <span style="margin-left: 5px;">Active</span>
</div>
</form>
  <!-- Right Side: Buttons -->
  <div class="d-flex gap-2 justify-content-end pe-5 fixed-bottom-buttons">
    <button type="button" class="cancel-btn btn btn-secondary" (click)="handleCancel()">Cancel</button>
    <button type="button" class="submit-btn btn btn-primary"
      [disabled]="!isFormValid()" (click)="myForm.onSubmit($event)">Submit</button>
  </div>
  
